import axios from "axios";
import { BASE_URL } from "../constants/config";
import { getCredentials } from "./helpers";

/**
 * Authenticated PDF download.
 * Fetches a PDF endpoint with the JWT bearer token, then triggers a
 * browser download. Works for endpoints like:
 *   - /api/loans/{id}/contract/
 *   - /api/loans/{id}/schedule-pdf/
 *   - /api/investments/{id}/contract/
 *
 * If `open` is true, opens the blob in a new tab instead of forcing a save.
 */
export const downloadPdf = async (
  path: string,
  filename: string,
  options: { open?: boolean } = {}
): Promise<void> => {
  const creds = getCredentials();
  const token = creds?.access;
  if (!token) throw new Error("Not authenticated");

  const resp = await axios({
    method: "get",
    url: `${BASE_URL}/${path}`,
    headers: { Authorization: `Bearer ${token}` },
    responseType: "blob",
  });

  const blob = new Blob([resp.data], { type: "application/pdf" });
  const url = URL.createObjectURL(blob);

  if (options.open) {
    window.open(url, "_blank", "noopener,noreferrer");
    // Revoke after the new tab has a chance to load
    setTimeout(() => URL.revokeObjectURL(url), 60_000);
    return;
  }

  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
};
